// extracted by mini-css-extract-plugin
module.exports = {"EstimateHeader":"Page_EstimateHeader__jUSO6","EstimateHeaderTitle":"Page_EstimateHeaderTitle__2a8ZO"};